import { getSignInType } from './getSignInType';
import type { NativeLsrMetricType } from 'mini-host-bridge/lib/types/LiteScenarioData';

/**
 * Outlook Lite android host sends LSR numbers as part of the initial config.
 * It has load times for various checkpoints at native end listed below
 * 1. App launch
 * 3. Web view launch
 * 4. Config request and response time
 * This function parses it.
 */
export const parseOutlookLiteLsrData = (lsr: NativeLsrMetricType) => {
    try {
        const {
            IsInteractiveSignIn,
            AppLaunchedAt,
            GetconfigReceivedAt,
            GetconfigAnsweredAt,
            READY_TO_LOAD_MINI_OWA,
        } = lsr;
        const getAbsoluteTime = (time: number) => time - AppLaunchedAt;

        return {
            // web view ready to load. Time spent on native before mini-owa starts loading.
            n_wr: getAbsoluteTime(READY_TO_LOAD_MINI_OWA),
            // get-config received
            n_gcr: getAbsoluteTime(GetconfigReceivedAt),
            // get-config answered
            n_gca: getAbsoluteTime(GetconfigAnsweredAt),
            // sign-in type
            i_sign: getSignInType(IsInteractiveSignIn),
        };
    } catch (error) {
        return {};
    }
};
